export const COLORS = {
  BLACK: `var(--color-black)`,
  RED: `var(--color-red)`,
  GREEN: `var(--color-green)`,
  YELLOW: `var(--color-yellow)`,
  BLUE: `var(--color-blue)`,
  PINK: `var(--color-pink)`,
  CYAN: `var(--color-cyan)`,
  GREY: `var(--color-grey)`,
};
